export default __webpack_public_path__ + "static/media/cashtab.fdeb8d05.png";